module.exports = __webpack_public_path__ + "static/img/kjdy06.aebfd36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy06.png
// module id = 25
// module chunks = 0